import jobQuotesReducer, {
    ToolkitJobQuotesActions,
} from "@store/Framework/Store/Toolkit/Data/JobQuotes/JobQuotesReducer";
import { combineReducers } from "redux";

const dataReducers = {
    jobQuotes: jobQuotesReducer,
};

export type ToolkitDataActions = ToolkitJobQuotesActions;
export default combineReducers(dataReducers);
